import React from 'react';
import File from 'components/Browser/components/File';

const Files = ({ files, active, onSelect, setActive }) => {
	return (
		<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
			{files?.map(file =>
				<File
					key={file.name}
					file={file}
					active={active}
					onSelect={onSelect}
					setActive={setActive}
				/>
			)}
		</div>
	);
};

export default Files;